// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YeId","colMin":"styles_colMin__1aHC9"};